//@ts-nocheck
import React, { useEffect, useState, useTransition } from "react";
import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import SubHeader, {
  SubHeaderRight,
} from "../../../layout/SubHeader/SubHeader";
import PaddlePay from "../../../components/payment/PaddlePay";
import Spinner from "../../../components/bootstrap/Spinner";
import Button from "../../../components/bootstrap/Button";
import subscriptionState from "../../../shared/mobx/subscription-state";
import { observer } from "mobx-react";
import userState from "../../../shared/mobx/user-state";
import auth from "../../../shared/mobx/auth-state";

import { formatNumberWithDecimal } from "../../../helpers/helpers";
import { usePaddle } from "../../../hooks/usePaddle";
import settingsState from "../../../shared/mobx/settings-state";

const currencyMapper = {
  USD: "$",
};

const qualityOrder = { low: 1, medium: 2, high: 3 };
const desktopKeywords = ["desktop", "laptop"];
const ipadKeywords = ["ipad"];
const mobileKeywords = ["iphone", "samsung", "mobile", "galaxy"];

const getDevicePriority = (value = "") => {
  const val = value.toLowerCase();
  if (desktopKeywords.some((k) => val.includes(k))) return 1;
  if (ipadKeywords.some((k) => val.includes(k))) return 2;
  if (mobileKeywords.some((k) => val.includes(k))) return 3;
  return 4;
};

const sortAccessDataByPriority = (accessData) => {
  if (!accessData || typeof accessData !== "object") return accessData;

  const sortedEntries = Object.entries(accessData).map(([key, value]) => {
    if (
      value &&
      typeof value === "object" &&
      value.options &&
      typeof value.options === "object"
    ) {
      let sortedOptions = Object.entries(value.options);

      if (key === "quality") {
        sortedOptions.sort(([, a], [, b]) => {
          return (
            (qualityOrder[a.value?.toLowerCase()] ?? 99) -
            (qualityOrder[b.value?.toLowerCase()] ?? 99)
          );
        });
      }

      if (key === "format") {
        sortedOptions.sort(([, a], [, b]) => {
          return getDevicePriority(a.value) - getDevicePriority(b.value);
        });
      }

      return [
        key,
        {
          ...value,
          options: Object.fromEntries(sortedOptions),
        },
      ];
    }

    return [key, value];
  });

  return Object.fromEntries(sortedEntries);
};

const Packages = () => {
  const [activeTab, setActiveTab] = useState("month");
  const [isLoading, setLoading] = useState(true);
  const [description, setDescription] = useState([]);
  const [activePackageId, setActivePackageId] = useState(null);
  const [isPending, startTransition] = useTransition();
  const [remainingPdfLimit, setRemainingPdfLimit] = useState(null);
  const [isLoadingPdfLimit, setIsLoadingPdfLimit] = useState(true);
  const [currentpackage, setCurrentPackage] = useState(null);

  const onCheckoutComplete = () => {
    setTimeout(() => {
      auth.clearPackageId();
      window.location.href = "/dashboard";
    }, 2000);
  };

  const paddle = usePaddle(
    {
      environment: settingsState.paddleEnviroment?.environment || 'sandbox',
      token: settingsState.paddleEnviroment?.token || ''
    },
    onCheckoutComplete,
    () => {}
  );

  useEffect(() => {
    startTransition(() => {
      const fetchlimitData = async () => {
        setIsLoadingPdfLimit(true);
        const data_ = await userState.getUserStats();
        setRemainingPdfLimit(data_.pdfdata.remaining_pdf_limit);
        setIsLoadingPdfLimit(false);
      };
      fetchlimitData();
    });

    const fetchData = async () => {
      const planId = await subscriptionState.getActiveSubscriptionPlan();
      setCurrentPackage(planId);
      setActivePackageId(planId?.plan_id);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchSubscriptionDescriptions = async () => {
      setLoading(true);
      const packageList =
        await subscriptionState.getSubscriptiondescriptionPlans(false);

      const sortedDescription = packageList.access.map((plan) => ({
        ...plan,
        access: sortAccessDataByPriority(plan.access),
      }));

      setDescription(sortedDescription);

      setLoading(false);
    };

    fetchSubscriptionDescriptions();
  }, [activePackageId]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const mapPackages = (data, cycle) => {
    if (!Array.isArray(data)) return [];

    return data
      .filter((plan) => plan.interval === cycle)
      .map((plan) => ({
        id: plan.id,
        name: plan.title,
        features: [plan.description],
        price: `${currencyMapper[plan.unit_price?.currency_code] ?? plan.unit_price?.currency_code}${formatNumberWithDecimal(plan.unit_price?.amount)}/${plan.interval}`,
        icon: plan.icon,
      }));
  };
  

  const setEqualHeightForPackages = () => {
    const packageCards = document.querySelectorAll(".packege-detail");
    let maxHeight = 0;

    packageCards.forEach((card) => {
      card.style.height = "auto";
      maxHeight = Math.max(maxHeight, card.clientHeight);
    });

    packageCards.forEach((card) => {
      card.style.height = `${maxHeight}px`;
    });
  };

  useEffect(() => {
    if (!isLoading) {
      setEqualHeightForPackages();
    }
  }, [isLoading, description]);

  // const updateIsActive = async (priceId) => {
  //   // setTimeout(() => {
  //   //   setActivePackageId(priceId);
  //   // }, 2000);
  //   // try {
  //   //   // First, wait for the backend to process the change
  //   //   await new Promise(resolve => setTimeout(resolve, 2000));
      
  //   //   // Then fetch updated data
  //   //   const [subscription, pdfData] = await Promise.all([
  //   //     subscriptionState.getActiveSubscriptionPlan(),
  //   //     await userState.getUserStats()
  //   //   ]);
      
  //   //   setCurrentPackage(subscription);
  //   //   setRemainingPdfLimit(pdfData.pdfdata.remaining_pdf_limit);
  //   //   setActivePackageId(subscription?.plan_id);
  //   // } catch (error) {
  //   //   console.error("Error updating after plan change:", error);
  //   // }
  //   try {
  //     // Use the retry mechanism
  //     await refreshAllDataWithRetry();
  //   } catch (error) {
  //     console.error("Failed to update after plan change:", error);
  //     // Fallback to full page reload if all retries fail
  //     window.location.reload();
  //   }
  // };
  // const refreshAllDataWithRetry = async (retries = 3, delay = 1000) => {
  //   try {
  //     const [subscription, userStats] = await Promise.all([
  //       subscriptionState.getActiveSubscriptionPlan(true),
  //       userState.getUserStats(true)
  //     ]);
      
  //     if (subscription?.plan_id === priceId) {
  //       setCurrentPackage(subscription);
  //       setRemainingPdfLimit(userStats.pdfdata.remaining_pdf_limit);
  //       setActivePackageId(subscription.plan_id);
  //       return true;
  //     }
  //     throw new Error("Data mismatch");
  //   } catch (error) {
  //     if (retries > 0) {
  //       await new Promise(resolve => setTimeout(resolve, delay));
  //       return refreshAllDataWithRetry(retries - 1, delay * 1.5);
  //     }
  //     throw error;
  //   }
  // };

  const updateIsActive = async (priceId) => {
    try {
      await refreshAllDataWithRetry(priceId);
    } catch (error) {
      console.error("Failed to update after plan change:", error);
      // If retries fail, last resort: reload
      window.location.reload();
    }
  };
  
  const refreshAllDataWithRetry = async (priceId, retries = 4, delay = 1500) => {
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        // Force API to bypass cache
        const [subscription, userStats] = await Promise.all([
          subscriptionState.getActiveSubscriptionPlan(true),
          userState.getUserStats(true)
        ]);
  
        setCurrentPackage(subscription);
        setRemainingPdfLimit(userStats.pdfdata.remaining_pdf_limit);
        setActivePackageId(subscription?.plan_id);
  
        // ✅ Success if we see the new plan or cancel reflected
        if (!priceId || subscription?.plan_id === priceId || subscription === null) {
          return;
        }
      } catch (err) {
        console.warn(`Retry ${attempt} failed`, err);
      }
      // Wait before retry
      await new Promise(res => setTimeout(res, delay));
    }
    throw new Error("All retries failed");
  };
  

  return (
    <PageWrapper title="Subscriptions">
      <Page>
        <div className="row">
          <div className="col-12 my-3">
            <SubHeader className="plan-btns">
              <SubHeaderRight>
                <Button
                  color="primary"
                  isLight
                  onClick={() => setActiveTab("month")}
                  isActive={activeTab === "month"}
                >
                  Monthly
                </Button>
                <Button
                  color="primary"
                  isLight
                  onClick={() => setActiveTab("year")}
                  isActive={activeTab === "year"}
                >
                  Yearly
                </Button>
              </SubHeaderRight>
            </SubHeader>
          </div>

          <div className="col-12 plan-app-wrappers mb-5 pb-5">
            <div className="packages">
              {isLoading ? (
                <Spinner size="4rem" color="danger" />
              ) : (
                <div className="row">
                  {description
                    .filter((plan) => plan.interval === activeTab)
                    .map((plan, index) => {
                      const accessData = plan.access;
                      const isActivePackage = plan.plan_id === activePackageId;

                      return (
                        <div key={index} className="col-12 col-md-6 col-lg-3">
                          <div className="package card-stretch-full">
                            <div className="packege-header">
                              <div className="packege-price">
                                <h3 className="text-xl font-bold text-white">
                                  {plan.title}
                                </h3>
                                <p className="price">
                                  {plan.unit_price
                                    ? `${currencyMapper[plan.unit_price.currency_code] ?? plan.unit_price.currency_code} ${formatNumberWithDecimal(plan.unit_price.amount)} / ${plan.interval}`
                                    : "No price available"}
                                </p>
                              </div>
                              <img
                                src={`/images/plan/${plan.icon}`}
                                alt={plan.title}
                                className="package-icon"
                              />
                            </div>
                            <div className="packege-detail">
                              <div
                                className="text-sm mb-2"
                                dangerouslySetInnerHTML={{
                                  __html: plan.description,
                                }}
                              />
                              <span className="text-uppercase">FEATURES</span>
                              <ul className="list-disc list-inside">
                                {Object.entries(accessData).map(
                                  ([key, value]) => {
                                    if (
                                      value &&
                                      typeof value === "object" &&
                                      value.label &&
                                      value.options
                                    ) {
                                      return (
                                        <li key={key}>
                                          <strong className="p-0">
                                            {value.tooltip ? (
                                              <tooltip className="custom-tooltip">
                                                {value.label}
                                                <span className="custom-tooltip-text">
                                                  {value.tooltip_text}
                                                </span>
                                              </tooltip>
                                            ) : (
                                              value.label
                                            )}
                                          </strong>
                                          <ul className="ps-3">
                                            {Object.entries(
                                              value.options
                                            ).map(([subKey, subValue]) => (
                                              <li key={subKey}>
                                                {subValue.tooltip ? (
                                                  <tooltip className="custom-tooltip">
                                                    {subValue.label &&
                                                      `${subValue.label} : `}
                                                    {subValue.value}
                                                    <span className="custom-tooltip-text">
                                                      {
                                                        subValue.tooltip_text
                                                      }
                                                    </span>
                                                  </tooltip>
                                                ) : (
                                                  <>
                                                    {subValue.label &&
                                                      `${subValue.label} : `}
                                                    {subValue.value}
                                                  </>
                                                )}
                                              </li>
                                            ))}
                                          </ul>
                                        </li>
                                      );
                                    } else if (
                                      typeof value === "string" ||
                                      typeof value === "number"
                                    ) {
                                      return (
                                        <li key={key}>
                                          <strong>
                                            {key.charAt(0).toUpperCase() +
                                              key.slice(1)}
                                            :
                                          </strong>{" "}
                                          {value}
                                        </li>
                                      );
                                    }
                                    return null;
                                  }
                                )}
                              </ul>
                            </div>
                            <div className="packege-btn">
                              {!isLoadingPdfLimit && (
                                <PaddlePay
                                  pending={isPending}
                                  className="subscribe-btn"
                                  currentPackage={currentpackage}
                                  // updateIsActive={updateIsActive}
                                  updateIsActive={(id) => updateIsActive(id)}
                                  paddle={paddle}
                                  pdfLimit={remainingPdfLimit}
                                  priceId={plan.plan_id}
                                  packagePrice={parseFloat(
                                    plan.unit_price.amount
                                  )}
                                  isActive={isActivePackage}
                                  debugMode={true}
                                  {...(auth.currentUser.selected_plan !==
                                    null &&
                                  auth.currentUser.customer_id === null
                                    ? {
                                        selected_plan: true,
                                        package_id:
                                          auth.currentUser.selected_plan,
                                      }
                                    : {})}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </div>
        </div>
      </Page>
    </PageWrapper>
  );
};

export default observer(Packages);
